export default Route => {
  // 其他
  Route.group({ prefix: "/salary" }, () => {
    Route.view("/calculator", () =>
      import(/* webpackChunkName: "other" */ "../views/salary/calculator.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
    Route.view("/trial", () =>
      import(/* webpackChunkName: "other" */ "../views/salary/trial.vue")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });

  Route.group({ prefix : "/outer"}, () => {
    Route.view("/category/search/:comId(\\d+)", () =>
        import(/* webpackChunkName: "other" */ "../views/other/CategorySearch")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });
  Route.group({ prefix : "/privacy"}, () => {
    Route.view("/content", () =>
        import(/* webpackChunkName: "other" */ "../views/other/PrivacyContent")
    ).options({
      meta: {
        layout: "empty"
      }
    });
  });
  Route.group({ prefix : "/noticeTK"}, () => {
    Route.view("/notice/:productId(\\d+)", () =>
        import(/* webpackChunkName: "other" */ "../views/other/Notice")
    ).options({
      meta: {

      }
    });
  });
};
